'use strict';

angular.module('more.ui.form-builder', ['more.ui.form']);
